import { logUsage } from 'owa-analytics';
import onCommitThemeChange from 'owa-options-actions/lib/onCommitThemeChange';
import themeChanged from 'owa-options-actions/lib/themeChanged';
import { updateUserOptions } from 'owa-options-core';
import { getCurrentThemeId, loadTheme } from 'owa-theme';
import setUserTheme from '../services/setUserTheme';

const OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingTheme';

export default async function commitThemeChange(themeId?: string) {
    if (themeId) {
        loadTheme(themeId);
    }

    let newThemeId = getCurrentThemeId();

    onCommitThemeChange(newThemeId);
    updateUserOptions({ ThemeStorageId: newThemeId });
    await setUserTheme(newThemeId);
    themeChanged();
}

export function commitQuickThemeChange(themeId: string) {
    logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [
        themeId /* What theme the user chose */,
        getCurrentThemeId() /* What theme the user is switching away from */,
    ]);

    commitThemeChange(themeId);
}
